import { render, staticRenderFns } from "./VatRowForm.vue?vue&type=template&id=c5b9d108&"
import script from "./VatRowForm.vue?vue&type=script&lang=js&"
export * from "./VatRowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports